import { Reducer } from 'redux';
import { ILoanApplicationActions, ILoanApplicationContractData, ILoanApplicationsData } from '../actions/loanApplicationAction';
import { LoanApplicationActionTypes } from '../constants/actionTypes';
import { ILoanApplication } from '../types/LoanApplication';

// Define the initial state
const initialState: ILoanApplicationState = {
  loanApplicationUpdateApiErrors: undefined,
  loanApplicationUpdatedState: undefined,
  loanApplicationsData: undefined,
  loanApplicationsGetApiErrors: undefined,
  loanApplicationUpdateInProgress: false,
  loanApplicationContractData: undefined,
  loanApplicationContractErrors: undefined,
  isLoanApplicationContractInprogress: false,
  isLoanApplicationContractCompleted: false,
};

export interface ILoanApplicationUpdateState {
  readonly loanApplicationUpdatedState: ILoanApplication | undefined;
  readonly loanApplicationUpdateApiErrors: string[] | undefined;
  readonly loanApplicationUpdateInProgress: boolean;
}

export interface ILoanApplicationsGetState {
  readonly loanApplicationsData: ILoanApplicationsData | undefined;
  readonly loanApplicationsGetApiErrors: string[] | undefined;
}

export interface ILoanApplicationContractGetState {
  readonly loanApplicationContractData: ILoanApplicationContractData | undefined;
  readonly loanApplicationContractErrors: string[] | undefined;
  isLoanApplicationContractInprogress: boolean | undefined,
  isLoanApplicationContractCompleted: boolean | undefined,
}

export interface ILoanApplicationState
  extends ILoanApplicationsGetState, ILoanApplicationUpdateState,
  ILoanApplicationContractGetState { }

const loanApplicationReducer: Reducer<ILoanApplicationState, ILoanApplicationActions> = (
  state = initialState,
  action: ILoanApplicationActions,
) => {
  switch (action.type) {
    case LoanApplicationActionTypes.GET_LOAN_APPLICATIONS:
      return {
        ...state,
        loanApplicationsData: action.loanApplicationsData,
        loanApplicationsGetApiErrors: undefined,
      };
    case LoanApplicationActionTypes.ERROR_GET_LOAN_APPLICATIONS:
      return {
        ...state,
        loanApplicationsData: undefined,
        loanApplicationsGetApiErrors: action.loanApplicationErrors,
      };
    case LoanApplicationActionTypes.UPDATE_LOAN_APPLICATION:
      return {
        ...state,
        loanApplicationUpdatedState: action.loanApplicationData,
        loanApplicationUpdateApiErrors: undefined,
        loanApplicationUpdateInProgress: false,
      };
    case LoanApplicationActionTypes.ERROR_UPDATE_LOAN_APPLICATION:
      return {
        ...state,
        loanApplicationUpdatedState: undefined,
        loanApplicationUpdateApiErrors: action.loanApplicationErrors,
        loanApplicationUpdateInProgress: false,
      };
    case LoanApplicationActionTypes.UPDATE_LOAN_APPLICATION_INPROGRESS:
      return {
        ...state,
        loanApplicationUpdatedState: undefined,
        loanApplicationUpdateApiErrors: undefined,
        loanApplicationUpdateInProgress: true,
      };
    case LoanApplicationActionTypes.GET_LOAN_APPLICATION_CONTRACT:
      return {
        ...state,
        loanApplicationContractData: action.loanApplicationContractData,
        loanApplicationContractErrors: undefined,
        isLoanApplicationContractInprogress: false,
      };
    case LoanApplicationActionTypes.ERROR_GET_LOAN_APPLICATION_CONTRACT:
      return {
        ...state,
        loanApplicationContractData: undefined,
        loanApplicationContractErrors: action.loanApplicationContractErrors,
        isLoanApplicationContractInprogress: false,
      };
    case LoanApplicationActionTypes.GET_LOAN_APPLICATION_CONTRACT_INPROGESS:
      return {
        ...state,
        isLoanApplicationContractInprogress: action.isLoanApplicationContractInprogress,
        isLoanApplicationContractCompleted: false,
      };
    case LoanApplicationActionTypes.GET_LOAN_APPLICATION_CONTRACT_COMPLETED:
      return {
        ...state,
        isLoanApplicationContractInprogress: false,
        isLoanApplicationContractCompleted: action.isLoanApplicationContractCompleted,
      };
    default:
      return state;
  }
};

export default loanApplicationReducer;
